import React from 'react';
import { RadioGroupControl } from '../../Components/RadioGroupControl';
import { MedicationType } from '../../Contracts/MedicationModels';
export var DaaRequired;
(function (DaaRequired) {
    DaaRequired["Yes"] = "yes";
    DaaRequired["No"] = "no";
})(DaaRequired || (DaaRequired = {}));
export var DaaSelectorField = function (props) {
    if (props.currentMedicationType === MedicationType.TakeHomeScript ||
        props.currentMedicationType === MedicationType.EnrmcScript ||
        props.currentMedicationType === MedicationType.ComplementaryTherapyOrder)
        return (React.createElement(RadioGroupControl, { readOnly: props.readOnly, value: props.daaRequired, label: 'DAA required?', options: [
                {
                    label: 'Yes',
                    value: DaaRequired.Yes
                },
                {
                    label: 'No',
                    value: DaaRequired.No
                }
            ], onChange: function (_, value) { return props.onChange(value); }, removeLastControlMargin: true }));
    return null;
};
